module.exports = __webpack_public_path__ + "static/media/Samasya P Pramod_.d763d5bf.jpg";